import Thumbnail from './ThumbnailContainer';
export default Thumbnail;
